<template>
  <div>
    <template v-if="!isView">
      <div class="content">
        <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}室信息</h3>
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
            <!-- <el-form-item label="所属院系">
         <el-tag>{{$refs.organDia?$refs.organDia.nodeArrName:''}}</el-tag>&nbsp;<el-button type="primary" @click="dialogOpen">选择</el-button>
        </el-form-item> -->
            <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
            <!-- <el-form-item :label="`${$store.state.themeTitle}室名称">
          <el-input v-model="formInline.training_name" clearable placeholder="请输入名称"></el-input>
        </el-form-item> -->
            <el-form-item label="所属院系">
              <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell"
                @handleOrganQuery="handleOrganQuery1"></OrganDialog>
              <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
                @clear="handeleClear1" clearable></el-input>
            </el-form-item>
            <el-form-item :label="`${$store.state.themeTitle}室编号`">
              <el-input v-model="formInline.training_no" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item :label="`${$store.state.themeTitle}室名称`">
              <!-- <el-select v-model="formInline.training_name" clearable filterable
                :placeholder="`请选择${$store.state.themeTitle}室`">
                <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
                  :value="item.training_name"></el-option>
              </el-select> -->
              <el-input v-model="formInline.training_name" clearable placeholder="请输入"></el-input>
            </el-form-item>
            
            <el-form-item :label="`${$store.state.themeTitle}室基地名称`">
              <el-input v-model="formInline.training_base_name" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="`${$store.state.themeTitle}室类型`">
              <el-select v-model="formInline.room_type" clearable :placeholder="`请选择${$store.state.themeTitle}室类型`">
                <el-option value="">全部</el-option>
                <el-option v-for="item in $store.state.roomType" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="目前状态">
              <el-select v-model="formInline.state" clearable filterable placeholder="请选择">
                <el-option v-for="item in $store.state.uses" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="安全负责人">
              <el-input v-model="formInline.secure_person" clearable placeholder="请输入安全负责人"></el-input>
            </el-form-item>
            <el-form-item label="安全负责人联系电话">
              <el-input v-model="formInline.secure_phone" clearable placeholder="请输入安全负责人联系电话"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="分  级" prop="level">
              <el-select v-model="formInline.level" filterable clearable style="width:216px;" placeholder="请选择分级">
                <el-option v-for="item in $store.state.params.level_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="校  区">
              <el-select v-model="formInline.school_area" clearable filterable placeholder="请选择校区"
                @change="handleLinkageChange('formInline', 'area')">
                <el-option v-for="item in buildingTree" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="楼宇名称">
              <el-select v-model="formInline.building_name" clearable filterable placeholder="请选择楼宇"
                @change="handleLinkageChange('formInline', 'building')">
                <el-option v-for="item in buildingOptionsOf('formInline')" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房间号">
              <el-select v-model="formInline.room_name" clearable filterable placeholder="请选择房间号">
                <el-option v-for="item in roomOptionsOf('formInline')" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="主要面向专业">
          <el-input v-model="formInline.major" clearable placeholder="请输入主要面向专业"></el-input>
        </el-form-item> -->
            <el-form-item>
              <el-button type="primary" @click="handleQuery">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleAdd()">新增</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="downloadFile">下载{{ $store.state.themeTitle }}室导入模板</el-button>
            </el-form-item>
            <el-form-item>
              <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
                :btnTitle="btnTitle"></Importt>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleBatchDel">批量删除</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :disabled="exportTitle == '导出中...'" @click="handleExportByUrl(formInline)">{{
                exportTitle }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <custom-table :data="tableData" border style="width: 100%"
            @selection-change="handleSelectionChange(...arguments, 'id')">
            <custom-table-column type="selection" width="40">
            </custom-table-column>
            <custom-table-column fixed prop="training_no" :label="`${$store.state.themeTitle}室编号`" width="160">
            </custom-table-column>
            <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" min-width="180">
            </custom-table-column>
            <!-- <custom-table-column prop="room_type_desc" :label="`${$store.state.themeTitle}室类型`" width="160">
            </custom-table-column>
            <custom-table-column prop="room_category_desc" :label="`${$store.state.themeTitle}室类别`" width="160">
            </custom-table-column>
            <custom-table-column prop="state" label="目前状态" width="100">
            </custom-table-column>
            <custom-table-column prop="jlrq" label="建立日期" width="180">
            </custom-table-column> -->
            <!-- <custom-table-column prop="xxdm" label="学校代码" width="120">
            </custom-table-column> -->
            <custom-table-column prop="structure_1" label="所属院系" width="160">
            </custom-table-column>
            <!-- <custom-table-column prop="major" label="专业" width="160">
            </custom-table-column> -->
            <!-- <custom-table-column prop="level_name" :label="`${$store.state.themeTitle}室分级" width="120">
            </custom-table-column> -->
            <!-- <custom-table-column prop="school_area" label="校区" width="140">
            </custom-table-column>
            <custom-table-column prop="building_name" label="楼宇名称" min-width="140">
            </custom-table-column>
            <custom-table-column prop="room_name" label="房间号" width="160">
            </custom-table-column>
            <custom-table-column prop="area" label="房间使用面积(m²)" width="140">
            </custom-table-column> -->
            <!-- <custom-table-column prop="room_name2" label="房间名称" width="160">
            </custom-table-column> -->
            <!-- <custom-table-column prop="type_desc" :label="`${$store.state.themeTitle}室类型" min-width="260">
            </custom-table-column> -->
            <!-- 
            <custom-table-column prop="person" :label="`${$store.state.themeTitle}室负责人`" width="140">
            </custom-table-column>
            <custom-table-column prop="fzr_no" label="负责人教工号" width="120">
            </custom-table-column>
            <custom-table-column prop="phone" :label="`${$store.state.themeTitle}室负责人电话`" width="160">
            </custom-table-column>
            <custom-table-column prop="concurrent_num" label="兼任人员数" width="120">
            </custom-table-column> -->
            <!-- <custom-table-column prop="mail" label="邮箱" width="180">
            </custom-table-column> -->
            <!-- <custom-table-column prop="place" label="位置" min-width="220">
        </custom-table-column> -->
            <!-- <custom-table-column prop="address" label="地点" min-width="220">
            </custom-table-column> -->
            <!-- <custom-table-column prop="secure_person" label="安全负责人" width="120">
            </custom-table-column>
            <custom-table-column prop="secure_phone" label="联系电话" width="120">
            </custom-table-column> -->
            <custom-table-column prop="state" label="目前状态" width="120">
            </custom-table-column>
            <custom-table-column prop="training_base_name" :label="`${$store.state.themeTitle}基地`" min-width="180">
            </custom-table-column>
            <!-- <custom-table-column prop="is_motor_room" label="是否机房" width="120">
            </custom-table-column>
            <custom-table-column prop="main_func" label="主要教学功能" width="220">
            </custom-table-column>
            <custom-table-column prop="workstation_num" label="工位数" width="120">
            </custom-table-column>
            <custom-table-column prop="yt" label="用途" width="160">
            </custom-table-column>
            <custom-table-column prop="plant_count" label="设备总数" width="120">
            </custom-table-column>
            <custom-table-column prop="plant_total" label="设备总值" width="120">
            </custom-table-column>
            <custom-table-column prop="ssgldwh" label="所属管理单位号" width="120">
            </custom-table-column>
            <custom-table-column prop="ssgldw" label="所属管理单位名称" width="140">
            </custom-table-column>
            <custom-table-column prop="sssxjdbh" :label="`所属基地编号`" width="140">
            </custom-table-column>
            <custom-table-column prop="hzqy" :label="`${$store.state.themeTitle}室合作企业`" width="160">
            </custom-table-column>
            <custom-table-column prop="creator_name" label="创建人" width="120">
            </custom-table-column>
            <custom-table-column prop="created_at" label="创建日期" width="180">
            </custom-table-column> -->
            <custom-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click="handleView(scope.row)" type="text" size="small">详情</el-button>
                <!-- <el-button @click="handleBind(scope.row)" type="text" size="small">绑定设备</el-button>
                <el-button @click="handleEqDetail(scope.row)" type="text" size="small">设备详情</el-button> -->
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
              </template>
            </custom-table-column>
          </custom-table>
          <div class="pageLine">
            <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
          </div>
        </div>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="780px">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="type == 'view'" label-width="140px"
            class="demo-ruleForm">
            <!-- <el-form-item label="学校代码" prop="xxdm">
              <el-input v-model="ruleForm.xxdm" placeholder="请输入学校代码" style="width:216px;"></el-input>
            </el-form-item> -->
            <el-form-item :label="`${$store.state.themeTitle}室编号`" prop="training_no">
              <el-input v-model="ruleForm.training_no" placeholder="请输入室编号" style="width:216px;"></el-input>
            </el-form-item>
            <el-form-item :label="`${$store.state.themeTitle}室名称`" prop="training_name">
              <el-input v-model="ruleForm.training_name" placeholder="请输入员名称" style="width:216px;"></el-input>
            </el-form-item>
            <el-form-item :label="`${$store.state.themeTitle}室类型`" prop="room_type">
              <el-select v-model="ruleForm.room_type" style="width:216px;" placeholder="请选择室类型">
                <el-option v-for="item in $store.state.roomType" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$store.state.themeTitle}室类别`" prop="room_category">
              <el-select v-model="ruleForm.room_category" style="width:216px;" placeholder="请选择室类别">
                <el-option v-for="item in $store.state.roomCategory" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item :label="`${$store.state.themeTitle}室分级`" prop="level_id">
              <el-select v-model="ruleForm.level_id" filterable clearable style="width:216px;" placeholder="请选择室分级">
                <el-option v-for="item in $store.state.params.level_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item :label="`${$store.state.themeTitle}基地`" prop="training_base_id">
              <el-select v-model="ruleForm.training_base_id" style="width:216px;" filterable placeholder="请选基地">
                <el-option v-for="item in bases" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="建立日期" prop="jlrq">
              <el-date-picker type="date" placeholder="选择建立日期" value-format="yyyy-MM-dd" clearable
                v-model="ruleForm.jlrq" style="width:216px;"></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="所属院系" prop="structure_1">
          <el-input v-model="ruleForm.structure_1" placeholder="请输入所属院系" style="width:216px;"></el-input>
        </el-form-item> -->
            <el-form-item label="所属院系" prop="structure_1">
              <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
              </OrganDialog>
              <el-input v-model="selectName" placeholder="请选择所属院系" style="width:572px;" @focus="dialogOpen"
                @clear="handeleClear" clearable></el-input>
            </el-form-item>
            <el-form-item :label="`${$store.state.themeTitle}室负责人`" prop="person_id">
              <!-- <el-input v-model="ruleForm.person" placeholder="请输入负责人姓名" style="width:216px;"></el-input> -->
              <el-select v-model="ruleForm.person_id" clearable style="width:216px;" filterable :loading="loading"
                remote :remote-method="remoteMethod" @change="handleTeacherChange" placeholder="请选择负责人">
                <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
                  <p>{{ item.name }}</p>
                  <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入联系电话" style="width:216px;"></el-input>
            </el-form-item>
            <!-- <el-form-item label="邮  箱" prop="mail">
              <el-input v-model="ruleForm.mail" placeholder="请输入邮箱" style="width:216px;"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="位  置" prop="place">
          <el-input v-model="ruleForm.place" placeholder="请输入位置" style="width:216px;"></el-input>
        </el-form-item> -->
            <el-form-item label="地  点" prop="address">
              <el-input v-model="ruleForm.address" placeholder="请输入地点" style="width:216px;"></el-input>
            </el-form-item>
            <el-form-item label="安全负责人" prop="secure_person_id">
              <!-- <el-input v-model="ruleForm.secure_person" placeholder="请输入安全负责人姓名" style="width:216px;"></el-input> -->
              <el-select v-model="ruleForm.secure_person_id" clearable style="width:216px;" filterable
                :loading="loading" remote :remote-method="remoteMethod" @change="handleSecureTeacherChange"
                placeholder="请选择">
                <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
                  <p>{{ item.name }}</p>
                  <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系电话" prop="secure_phone">
              <el-input v-model="ruleForm.secure_phone" placeholder="请输入联系电话" style="width:216px;"></el-input>
            </el-form-item>
            <el-form-item label="兼任人员数" prop="concurrent_num">
              <el-input v-model.number="ruleForm.concurrent_num" placeholder="请输入数量" style="width:216px;"></el-input>
            </el-form-item>
            <el-form-item label="校  区" prop="school_area">
              <el-select v-model="ruleForm.school_area" filterable clearable style="width:216px;" placeholder="请选择校区"
                @change="handleLinkageChange('ruleForm', 'area')">
                <el-option v-for="item in buildingTree" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="楼宇名称" prop="building_name">
              <el-select v-model="ruleForm.building_name" filterable clearable style="width:216px;" placeholder="请选择楼宇"
                @change="handleLinkageChange('ruleForm', 'building')">
                <el-option v-for="item in buildingOptionsOf('ruleForm')" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房间号" prop="room_name">
              <el-select v-model="ruleForm.room_name" filterable clearable style="width:216px;" placeholder="请选择房间号">
                <el-option v-for="item in roomOptionsOf('ruleForm')" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="房间名称" prop="room_name2">
              <el-input v-model="ruleForm.room_name2" placeholder="请输入房间名称" style="width:216px;"></el-input>
            </el-form-item> -->
            <el-form-item label="面  积" prop="area">
              <el-input v-model="ruleForm.area" placeholder="请输入面积" style="width:198px;"></el-input> m²
            </el-form-item>
            <el-form-item label="目前状态" prop="state">
              <el-select v-model="ruleForm.state" filterable clearable style="width:216px;" placeholder="请选择目前状态">
                <el-option v-for="item in $store.state.uses" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否机房" prop="is_motor_room">
              <el-select v-model="ruleForm.is_motor_room" filterable clearable style="width:216px;"
                placeholder="请选择是否机房">
                <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
                  :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工位数" prop="workstation_num">
              <el-input v-model.number="ruleForm.workstation_num" placeholder="请输入数量" style="width:216px;"></el-input>
            </el-form-item>
            <!-- <el-form-item label="设备总值" prop="plant_total">
              <el-input v-model="ruleForm.plant_total" placeholder="请输入设备总值" style="width:216px;"></el-input>
            </el-form-item> -->
            <el-form-item label="用途" prop="yt">
              <el-input type="textarea" v-model="ruleForm.yt" maxlength="100" show-word-limit :rows="4"
                placeholder="请输入用途(不超过100字)" style="width:552px;"></el-input>
            </el-form-item>
            <el-form-item label="主要教学功能" prop="main_func">
              <el-input type="textarea" v-model="ruleForm.main_func" maxlength="100" show-word-limit :rows="4"
                placeholder="请输入主要教学功能(不超过100字)" style="width:552px;"></el-input>
            </el-form-item>
            <el-form-item label="所属管理单位号" prop="ssgldwh">
              <el-input v-model="ruleForm.ssgldwh" placeholder="请输入所属管理单位号" style="width:216px;"></el-input>
            </el-form-item>
            <el-form-item label="所属管理单位" prop="ssgldw">
              <el-input v-model="ruleForm.ssgldw" placeholder="请输入所属管理单位名称" style="width:216px;"></el-input>
            </el-form-item>
            <el-form-item label="所属基地编号" prop="sssxjdbh">
              <el-input v-model="ruleForm.sssxjdbh" placeholder="请输入所属基地编号" style="width:216px;"></el-input>
            </el-form-item>
            <el-form-item label="实验室合作企业" prop="hzqy">
              <el-input v-model="ruleForm.hzqy" placeholder="请输入实验室合作企业" style="width:216px;"></el-input>
            </el-form-item>
            <!-- <el-form-item label="主要面向专业" prop="major">
          <el-input v-model="ruleForm.major" placeholder="请输入主要面向专业" style="width:216px;"></el-input>
        </el-form-item> -->
            <el-form-item style="margin-top:8px;width:100%;text-align:right;">
              <el-button type="primary" v-if="type == 'add'" @click="submitForm('ruleForm')">确认</el-button>
              <el-button type="primary" v-if="type == 'edit'" @click="submitForm('ruleForm')">编辑</el-button>
              <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="设备绑定" :visible.sync="centerDialogVisible1" width="706px">
          <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
            <!-- <el-form-item label="设备编号" prop="device_no">
          <el-input v-model="ruleForm1.device_no" placeholder="请输入设备编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="device_name">
          <el-input v-model="ruleForm1.device_name" placeholder="请输入设备名称" style="width:216px;"></el-input>
        </el-form-item> -->
            <el-form-item label="设备名称" prop="device_no">
              <el-select v-model="ruleForm1.device_no" style="width:216px;" placeholder="请选择设备"
                @change="handleEqChange">
                <el-option v-for="item in eqs" :key="item.id" :label="item.device_name"
                  :value="item.device_no"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数量" prop="device_num">
              <el-input-number v-model="ruleForm1.device_num" placeholder="请输入数量"
                style="width:216px;"></el-input-number>
            </el-form-item>
            <el-form-item style="margin-top:8px;width:100%;text-align:right;">
              <el-button type="primary" @click="submitFormByFun('ruleForm1', bindDevice)">绑定</el-button>
              <el-button @click="resetForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="detailDialogVisible" width="706px">
          <div>
            <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
              <!-- <el-form-item label="日期">
            <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item> -->
              <el-form-item label="设备名称">
                <el-input v-model="formInline1.device_name" placeholder="请输入设备名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleQuery1">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleBindInfo">新增绑定</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <custom-table :data="tableData1" border style="width: 100%">
              <custom-table-column prop="device_no" label="设备编号" width="120">
              </custom-table-column>
              <custom-table-column prop="device_name" label="设备名称" min-width="150">
              </custom-table-column>
              <custom-table-column prop="device_num" label="数量" width="120">
              </custom-table-column>
              <custom-table-column prop="username" label="绑定人" width="150">
              </custom-table-column>
              <custom-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                  <el-button @click="handleDelet1(scope.row.id)" type="text" size="small">删除</el-button>
                </template>
              </custom-table-column>
            </custom-table>
            <div class="pageLine">
              <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="detailDialogVisible = false">取 消</el-button>
            <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
          </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
          <span>是否删除</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="deleteTarinRoom">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible1" width="400px">
          <span>是否解除该设备绑定！</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible1 = false">取 消</el-button>
            <el-button type="primary" @click="cancelBind">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinBuilding } from '@/assets/js/mixin/building';
import { number } from 'echarts';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate, mixinBuilding],
  data() {
    return {
      formInline: {
        structure_1: '',
        secure_person: '',
        secure_phone: '',
        school_area: '',
        building_name: '',
        room_name: '',
        major: '',
        room_type: '',
        training_name: '',
        training_no:'',
        training_base_name:'',
        level: '',
        state: '',
      },
      isView: false,
      selectName: '',
      organLabel: '',
      levell: [1],
      formInline1: {
        training_room_id: '',
        device_name: '',
      },
      tableData1: [],
      total1: 0,
      detailDialogVisible: false,
      centerDialogVisible1: false,
      dialogVisible1: false,
      ruleForm: {
        training_no: '',
        training_name: '',
        xxdm: '',
        structure_1: '',
        training_base_id: '',
        person_id: '',
        person: '',
        fzr_no: '',

        // place: '',
        address: '',
        phone: '',
        mail: '',
        secure_person: '',
        secure_person_id: '',
        secure_phone: '',
        school_area: '',
        building_name: '',
        level_id: '',
        room_name: '',
        room_name2: '',
        major: '',
        type: '',
        room_category: '',
        area: '',
        main_func: '',
        state: '投入使用',
        is_motor_room: '否',
        workstation_num: 0,
        concurrent_num: 0,
        plant_total: 0,
        ssgldwh: '',
        ssgldw: '',
        sssxjdbh: '',
        jlrq: '',
        hzqy: '',
      },
      ruleForm1: {
        training_room_id: '',
        device_no: '',
        device_name: '',
        device_num: '',
      },
      ruleFormTep1: {
        training_room_id: '',
        device_no: '',
        device_name: '',
        device_num: '',
      },
      rules: {
        training_no: [{ required: true, message: '请输入编号', trigger: 'blur' }],
        training_name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        // structure_1: [{ required: true, message: '请输入所属院系', trigger: 'change' }],
        structure_1: [{ required: true, message: '请选择所属院系' }],
        person_id: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        state: [{ required: true, message: '请选择', trigger: 'change' }],
        jlrq: [{ required: true, message: '请选择', trigger: 'change' }],
        // phone: [
        //   { validator: this.checkphone, trigger: 'blur' },
        // ],
        area: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkfloat, trigger: 'blur' }],
        // plant_total: [{ validator: this.checkfloat, trigger: 'blur' }],
        workstation_num: [{ required: true, message: '请输入', trigger: 'blur' }, { type: 'number', message: '工位数必须为数字值', trigger: 'blur' }],
        concurrent_num: [{ required: true, message: '请输入', trigger: 'blur' }, { type: 'number', message: '兼任人员数必须为数字值', trigger: 'blur' }],
        // place: [{ required: true, message: '请输入位置', trigger: 'blur' }],
        // address: [{ required: true, message: '请输入地点', trigger: 'blur' }],
        mail: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
        room_type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        room_category: [{ required: true, message: '请选择类别', trigger: 'change' }],
        training_base_id: [{ required: true, message: '请选择基地', trigger: 'change' }],
        secure_person_id: [{ required: true, message: '请输入', trigger: 'blur' }],
        // secure_phone: [{ validator: this.checkphone, trigger: 'blur' }],
        school_area: [{ required: true, message: '请选择', trigger: 'change' }],
        building_name: [{ required: true, message: '请选择', trigger: 'change' }],
        room_name: [{ required: true, message: '请输入', trigger: 'blur' }],

      },
      rules1: {
        device_no: [{ required: true, message: '请选择设备', trigger: 'change' }],
        // device_name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        device_num: [{ required: true, message: '请输入设备数量', trigger: 'blur' }],
      },
      bases: [],
      eqs: [],
      loading: false,
      users: [],
      action: '',
      downloadUrl: 'template/实验实训室导入模版.xlsx',
      downloadName: '实验实训室信息列表.xlsx',
      btnTitle: '导入实训室数据',
    };
  },
  beforeCreate() { },
  created() {
    this.action = `${this.baseUrlt}api/training/room/import`;
    this.exportUrl = `${this.baseUrlt}api/training/room/export`;
    this.getTrainBases();
    // this.$store.dispatch('getTarinMent');
    // this.$store.dispatch('getParams');

  },
  computed: {},
  mounted() { },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleEqDetail(row) {
      this.isView = true;
      this.$router.push({
        path: '/trainingRoom/trainingRoomToEq',
        query: {
          training_id: row.id,
          training_name: row.training_name,
        },
      });
    },
    handleView(row, filterArr = []) {
      this.type = 'view';
      this.title = '详情';
      this.selectName = ' '
      if (row.structure_1) {
        this.selectName = `${row.structure_1}`;
      }
      this.ruleForm = this.$until.delProp(row, filterArr);
      for (let key in this.ruleForm) {
        if (!this.ruleForm[key]) {
          this.ruleForm[key] = '  ';
        }
      }
      if (row.person && (JSON.stringify(this.users).indexOf(row.person_id) == -1)) {
        this.users.push({ id: row.person_id, name: row.person, number: row.fzr_no })
      }
      this.centerDialogVisible = true;
    },
    handleTeacherChange(val) {
      this.ruleForm.person = this.$until.getLabelName(this.users, 'id', 'name', val);
      this.ruleForm.fzr_no = this.$until.getLabelName(this.users, 'id', 'number', val);
    },
    handleSecureTeacherChange(val) {
      this.ruleForm.secure_person = this.$until.getLabelName(this.users, 'id', 'name', val);
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: this.$until.getPostsType([4])
      };
      // console.log(query)
      // return
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    handleEqChange(val) {
      this.ruleForm1.device_name = this.$until.getLabelName(this.eqs, 'device_no', 'device_name', val);
    },
    async getEqs() {
      let res = await this.getDataList('getDeviceIntoList');
      this.eqs = res.data.data;
    },
    handleDelet1(id) {
      this.delid = id;
      this.dialogVisible1 = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getTrainBases() {
      let params = {
        page: 1,
        size: 9999,
      };
      let res = await this.$api.query.getTrainBase(params);
      if (res.code == 0 && res.data) {
        this.bases = res.data.data;
      }
    },
    handleBind(row) {
      this.formInline1.training_room_id = row.id;
      this.ruleForm1.training_room_id = row.id;
      this.detailDialogVisible = true;
      this.handleQuery1();
      this.getEqs();

      // this.centerDialogVisible1 = true;
      // this.handleQuery1();
    },
    async cancelBind() {
      let params = { id: this.delid };
      let res = await this.$api.delet.cancelBind(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '解除绑定成功！',
        });
        this.dialogVisible1 = false;
        this.handleQuery1();
      }
    },
    clearState1() {
      this.centerDialogVisible1 = false;
      this.ruleForm1 = this.ruleFormTep1;
      this.getList1();
    },
    handleBindInfo() {
      this.centerDialogVisible1 = true;

      // this.formInline1.training_room_id = row.id;
      // this.detailDialogVisible = true;
      // this.handleQuery1();
    },
    async deleteTarinRoom() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteTarinRoom(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async bindDevice() {
      let params = this.$until.deleteNullPrototype(this.ruleForm1);
      let res = await this.$api.creat.creatDeviceBind(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.handleQuery1();
        this.clearState1();
      }
    },
    async createTarinRoom() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.createTarinRoom(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.refreshAndClear()
      }
    },
    async updateTarinRoom() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateTarinRoom(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
      }
      this.refreshAndClear()
    },
    refreshAndClear() {
      this.$store.dispatch('getTarinMent', { isRefresh: true });
      this.clearState();
    },
    getOrganList() {
      this.beforeGetOrgan({ limit: false });
      // this.beforeGetOrgan({ limit: false, needId: { val: true } });
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getRooms(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      if (row.structure_1) {
        this.selectName = `${row.structure_1}`;
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      if (row.person && (JSON.stringify(this.users).indexOf(row.person_id) == -1)) {
        this.users.push({ id: row.person_id, name: row.person, number: row.fzr_no })
      }
      this.centerDialogVisible = true;
    },
    async getList1() {
      let params = {
        page: this.$refs.pageChild1.page,
        size: this.$refs.pageChild1.size,
      };
      params.training_room_id = this.formInline1.training_room_id;
      params.device_name = this.formInline1.device_name;
      let res = await this.$api.query.getDevicesAlreadyBind(this.$until.deleteNullPrototype(params));
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },
    handleQuery1() {
      this.$nextTick(() => {
        this.$refs.pageChild1.page = 1;
        this.getList1();
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createTarinRoom();
          } else if (this.type == 'edit') {
            this.updateTarinRoom();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
